module.exports = __webpack_public_path__ + "img/model-3.c9084937.png";